import Vue from 'vue'

export default {
  getEventPurchases (eventId) {
    return Vue.prototype.$http.get(`/events/${eventId}/event_purchases`)
  },
}
